var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "178px",
    height: "132px",
    viewBox: "0 0 178 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_no_address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PERFIL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Perfil_no_address",
    transform: "translate(-329.000000, -496.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Direcciones",
    transform: "translate(127.000000, 395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_no_address",
    transform: "translate(203.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    points: "96 7.10542736e-15 132.189186 7.10542736e-15 143.856013 11.6668264 132.189186 23.3336528 96 23.3336528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,113 L176,113",
    id: "Path-3-Copy-3",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    transform: "translate(78.928006, 41.666826) scale(-1, 1) translate(-78.928006, -41.666826) ",
    points: "63 34 87.0898294 34 94.8560127 41.6668264 87.0898294 49.3336528 63 49.3336528"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy-2",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    points: "96 56 120.089829 56 127.856013 63.6668264 120.089829 71.3336528 96 71.3336528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,126 L96,0.5",
    id: "Line",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,142 L96,110",
    id: "Line-Copy",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    transform: "translate(96.000000, 126.000000) rotate(-270.000000) translate(-96.000000, -126.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.121385,113 L156.121385,94.4378326",
    id: "Path-5",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.194888,104.01191 C149.62957,103.328233 146.34691,100.136874 146.34691,94.4378326 C146.34691,88.7387911 149.62957,79.0037878 156.194888,65.2328227 C162.748697,80.4733528 166.025601,90.2083561 166.025601,94.4378326 C166.045708,100.007477 162.768803,103.198836 156.194888,104.01191 Z",
    id: "Path-6",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "74.2442431 113 59.5692509 98.3250078 44.8942588 113"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 2,
    cx: 56.5,
    cy: 78.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "52.5163372 105.195095 33.896367 86.5751247 7.54680483 112.924687"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoAddress);
export default __webpack_public_path__ + "static/media/ic_no_address.200327b2114f2c07f5b30a7f07abd0df.svg";
export { ForwardRef as ReactComponent };